/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
import * as React from 'react';
import 'drag-drop-touch/DragDropTouch';
import { Dropdown, ToggleButtonGroup } from 'react-bootstrap';
import { ExpandableSection } from '../ExpandableSection';
import { Button, ButtonColorType } from '../Button';
import { SvgImage } from '../SvgImage';
import FilterTag from '../TableFilter/FilterTag';
import { IconButton } from '../IconButton';
import { Select } from '../Select';
import { LabeledSelect } from '../LabeledSelect';
import { ColorSlider } from '../ColorSlider/ColorSlider';
import {
  getDeviceIconBySymbol,
  deviceActions,
  buzzerMelodies,
  buzzerMelodiesSelectOptions
} from '../../util/devices';
import { ICustomToggleFilterProps } from '../TableFilter/TableFilter.types';
import { DeviceActionType } from '../../util/devices/devices.types';
import { getAssetPath } from '../../util/images';
import {
  getActionDevice,
  outputDevicesFilterFunction
} from './CreateScenePanel.logic';
import { ClearButton, TableFilterForm } from '../TableFilter/TableFilter';
import {
  DropdownColorSelector,
  ConfiguratorColumnLabel,
  ConfiguratorColumnTitle,
  CreateSceneDragAreaInfo,
  CreatorPanel,
  DeviceItemLabel,
  DeviceItemTileContainer,
  DeviceItemTileWrapper,
  DeviceItemTitle,
  DevicesFilterButton,
  DevicesFilterDropdown,
  DevicesListToggleButton,
  DevicesListToggleContainer,
  DevicesPanel,
  DragDropInfoSceneContainer,
  RemoveActionButton,
  SceneActionColorSliderContainer,
  SceneActionDetailsWrapper,
  SceneActionParamContainer,
  SceneCreateParagraph,
  SearchInput,
  ToggleGroupBtn, InlineColorSelector, ActionParamWrapper
} from './CreateScenePanelComponents';
import { GridFullRow } from '../Grid';
import MenuIcon from '../icons/project-icons/Menu';
import FilterIcon from '../icons/project-icons/Filter';
import ScenePlaceholderIcon from './ScenePlaceholderIcon';

import './CreateScenePanel.scss';

const CustomToggle = React.forwardRef<HTMLButtonElement>(
  (buttonProps: ICustomToggleFilterProps, buttonRef) => {
    const { onClick } = buttonProps;
    return (
      <DevicesFilterButton
        type="button"
        onClick={e => {
          e.preventDefault();
          onClick(e);
        }}
        ref={buttonRef}
        data-testid="filter-button"
      >
        <FilterIcon />
      </DevicesFilterButton>
    );
  }
);

const CreateScenePanel = props => {
  const { onSceneChange } = props;
  // eslint-disable-next-line react/destructuring-assignment
  const [docks, setDocks] = React.useState(props.docks);
  // eslint-disable-next-line react/destructuring-assignment
  const [rooms, setRooms] = React.useState(props.rooms);
  // eslint-disable-next-line react/destructuring-assignment
  const [scene, setScene] = React.useState(props.sceneInEdit);
  const [showDevicesFilters, setShowDevicesFilters] = React.useState(false);
  const [filterState, setFilterState] = React.useState({
    roomType: null,
    deviceType: null,
    selectedRoomTypes: [],
    selectedDeviceTypes: []
  });
  const [searchPhrase, setSearchPhrase] = React.useState('');
  const [deviceTypes, setDeviceTypes] = React.useState([]);
  const [roomsTypes, setRoomsTypes] = React.useState([]);
  const [deviceInDrag, setDeviceInDrag] = React.useState(null);
  const [devicesListCollapsed, setDevicesListCollapsed] = React.useState(false);

  const refreshDeviceTypes = () => {
    const types = [];

    Object.values(rooms).forEach(({ id }) => {
      docks[id].forEach(dock => {
        dock.devices
          .filter(outputDevicesFilterFunction)
          .forEach(({ symbol, name }) => {
            if (!types.find(type => type.value === symbol)) {
              types.push({ value: symbol, label: name });
            }
          });
      });
    });

    setDeviceTypes(types);
  };
  const refreshRoomTypes = () => {
    const types = [
      ...rooms.map(room => ({ value: room.typeId, label: room.name }))
    ];

    setRoomsTypes(types);
  };
  const getDeviceNumberInDock = (deviceId, roomId, dockNumber) =>
    props.docks[roomId]
      .find(dock => dock.number === dockNumber)
      .devices.findIndex(device => device.id === deviceId);
  const setLedColor = (actionParameters, { hue, saturation }) => {
    actionParameters.Color = {
      hue,
      saturation
    };
    actionParameters.brightness = 0;

    setScene({
      ...scene
    });
  };
  const filterDockDevicesBySelectedActions = () => {
    const filteredDocks = {};

    Object.keys(props.docks).forEach(roomKey => {
      filteredDocks[roomKey] = props.docks[roomKey].map((dock, dockIndex) => {
        return {
          ...dock,
          devices: props.docks[roomKey][dockIndex].devices.filter(
            // eslint-disable-next-line @typescript-eslint/no-unused-vars-experimental
            (device, index) =>
              !scene.actions.some(
                action =>
                  action.dockNumber === dock.number &&
                  action.deviceNumber === index
              )
          )
        };
      });
    });

    setDocks({ ...filteredDocks });
  };

  React.useEffect(() => {
    filterDockDevicesBySelectedActions();
  }, [scene.actions]);
  React.useEffect(() => {
    setRooms(props.rooms);
    setDocks(props.docks);
    filterDockDevicesBySelectedActions();
  }, [props]);
  React.useEffect(() => {
    refreshDeviceTypes();
  }, [docks]);
  React.useEffect(() => {
    refreshRoomTypes();
  }, [rooms]);
  React.useEffect(() => {
    refreshDeviceTypes();
  }, [docks]);
  React.useEffect(() => {
    onSceneChange(scene);
  }, [scene]);

  return (
    <>
      <GridFullRow>
        <DevicesListToggleContainer>
          <DevicesListToggleButton
            onClick={() => setDevicesListCollapsed(!devicesListCollapsed)}
          >
            <MenuIcon />
          </DevicesListToggleButton>
          <span>Devices list</span>
        </DevicesListToggleContainer>
      </GridFullRow>
      {!devicesListCollapsed && (
        <DevicesPanel>
          <div className="create-scene-creator-configurator-devices">
            <ConfiguratorColumnTitle>Devices</ConfiguratorColumnTitle>
            <ConfiguratorColumnLabel>
              Create base of the scene
            </ConfiguratorColumnLabel>
          </div>
          <div className="create-scene-devices-search-wrapper">
            <SearchInput
              placeholder="Search"
              value={searchPhrase}
              onChange={value => setSearchPhrase(value)}
              styleType="standard"
            />
            <Dropdown
              show={showDevicesFilters}
              onToggle={() => {
                setShowDevicesFilters(!showDevicesFilters);
              }}
            >
              <Dropdown.Toggle id="filters-button" as={CustomToggle} />
              <DevicesFilterDropdown>
                <TableFilterForm>
                  <ClearButton
                    data-testid="DevicesFiltersDropdownBtn"
                    type="button"
                    className="small-text create-scene-filter-dropdown-clear-btn"
                    onClick={() => {
                      refreshDeviceTypes();
                      refreshRoomTypes();
                      setFilterState({
                        roomType: null,
                        deviceType: null,
                        selectedRoomTypes: [],
                        selectedDeviceTypes: []
                      });
                    }}
                  >
                    Clear all
                  </ClearButton>
                  <LabeledSelect
                    value={filterState.roomType}
                    onChange={({ value, label }) =>
                      setFilterState({
                        ...filterState,
                        roomType: { value, label }
                      })
                    }
                    label="Room"
                    placeholder="Select room"
                    options={roomsTypes}
                    testId="RoomFilterSelect"
                  />
                  <LabeledSelect
                    value={filterState.deviceType}
                    onChange={({ value, label }) =>
                      setFilterState({
                        ...filterState,
                        deviceType: { value, label }
                      })
                    }
                    label="Device type"
                    placeholder="Select device type"
                    options={deviceTypes}
                    testId="DeviceTypeFilterSelect"
                  />
                  <div className="d-flex justify-content-between create-scene-filter-dropdown-action-btns">
                    <Button
                      colorType={ButtonColorType.PRIMARY}
                      type="submit"
                      text="Filter"
                      testId="SaveDevicesFiltersBtn"
                      onClick={() => {
                        const selectedRoomTypes = filterState.roomType
                          ? [
                              ...filterState.selectedRoomTypes,
                              filterState.roomType
                            ]
                          : [...filterState.selectedRoomTypes];
                        const selectedDeviceTypes = filterState.deviceType
                          ? [
                              ...filterState.selectedDeviceTypes,
                              filterState.deviceType
                            ]
                          : [...filterState.selectedDeviceTypes];

                        if (filterState.deviceType) {
                          setDeviceTypes(
                            deviceTypes.filter(
                              deviceType =>
                                deviceType.value !==
                                filterState.deviceType.value
                            )
                          );
                        }

                        if (filterState.roomType) {
                          setRoomsTypes(
                            roomsTypes.filter(
                              roomType =>
                                roomType.value !== filterState.roomType.value
                            )
                          );
                        }

                        setFilterState({
                          roomType: null,
                          deviceType: null,
                          selectedRoomTypes,
                          selectedDeviceTypes
                        });
                      }}
                    />
                  </div>
                </TableFilterForm>
              </DevicesFilterDropdown>
            </Dropdown>
          </div>
          <div className="create-scene-selected-filters-container">
            {filterState.selectedRoomTypes.map(roomType => (
              <FilterTag
                filterKey={roomType.value}
                value={roomType.label}
                onRemoveTag={() => {
                  setRoomsTypes([...roomsTypes, roomType]);
                  setFilterState({
                    ...filterState,
                    selectedRoomTypes: filterState.selectedRoomTypes.filter(
                      type => type.value !== roomType.value
                    )
                  });
                }}
              />
            ))}
            {filterState.selectedDeviceTypes.map(deviceType => (
              <FilterTag
                filterKey={deviceType.value}
                value={deviceType.label}
                onRemoveTag={() => {
                  setDeviceTypes([...deviceTypes, deviceType]);
                  setFilterState({
                    ...filterState,
                    selectedDeviceTypes: filterState.selectedDeviceTypes.filter(
                      type => type.value !== deviceType.value
                    )
                  });
                }}
              />
            ))}
          </div>
          <div className="create-scene-rooms-wrapper">
            {rooms
              .filter(
                room =>
                  filterState.selectedRoomTypes.length === 0 ||
                  filterState.selectedRoomTypes.some(
                    selectedRoom => selectedRoom.value === room.typeId
                  )
              )
              .map(room => (
                <ExpandableSection
                  key={`room_${room.id}`}
                  title={room.name}
                  className="create-scene-room"
                >
                  <div className="create-scene-room-devices-wrapper">
                    {docks[room.id].map(dock =>
                      dock.devices
                        .filter(outputDevicesFilterFunction)
                        .filter(
                          device =>
                            filterState.selectedDeviceTypes.length === 0 ||
                            filterState.selectedDeviceTypes.some(
                              selectedRoom =>
                                selectedRoom.value === device.symbol
                            )
                        )
                        .filter(
                          device =>
                            searchPhrase.length === 0 ||
                            new RegExp(searchPhrase.toLocaleLowerCase()).test(
                              device.name.toLocaleLowerCase()
                            )
                        )
                        .map(device => (
                          <DeviceItemTileWrapper key={`device-${device.id}`}>
                            <DeviceItemTileContainer
                              draggable
                              onDragStart={() => {
                                setDeviceInDrag({
                                  dockNumber: dock.number,
                                  deviceNumber: getDeviceNumberInDock(
                                    device.id,
                                    room.id,
                                    dock.number
                                  ),
                                  action: Object.keys(device.actions)[0],
                                  actionParameters: deviceActions
                                    .find(
                                      deviceAction =>
                                        deviceAction.key ===
                                        Object.keys(device.actions)[0]
                                    )
                                    .value(),
                                  roomId: room.id,
                                  device
                                });
                              }}
                            >
                              <SvgImage
                                className="create-scene-device-icon"
                                inAssetsPath={getAssetPath(
                                  `${getDeviceIconBySymbol(device.symbol)}.svg`
                                )}
                              />
                              <div className="create-scene-device-item-text-wrapper">
                                <DeviceItemTitle>{device.name}</DeviceItemTitle>
                                <DeviceItemLabel>
                                  dock: {dock.number}
                                </DeviceItemLabel>
                              </div>
                            </DeviceItemTileContainer>
                          </DeviceItemTileWrapper>
                        ))
                    )}
                  </div>
                </ExpandableSection>
              ))}
          </div>
        </DevicesPanel>
      )}
      <CreatorPanel
        devicesListCollapsed={devicesListCollapsed}
        onDrop={() => {
          setScene({
            actions: [...scene.actions, deviceInDrag]
          });
          setDeviceInDrag(null);
        }}
        onDragOver={event => {
          event.preventDefault();
        }}
      >
        <DragDropInfoSceneContainer
          devicesListCollapsed={devicesListCollapsed}
          noActions={!scene.actions.length}
        >
          <ScenePlaceholderIcon />
          <SceneCreateParagraph>
            Drag & drop devices from left panel
          </SceneCreateParagraph>
        </DragDropInfoSceneContainer>

        <div className="create-scene-creator-configurator-header">
          <div className="create-scene-creator-configurator-parameters">
            <ConfiguratorColumnTitle>Parameters</ConfiguratorColumnTitle>
            <ConfiguratorColumnLabel>
              Set state, colors, intesity, melody or volume
            </ConfiguratorColumnLabel>
          </div>
        </div>
        <div className="create-scene-creator-configurator-content">
          {rooms.length > 0 &&
            Object.keys(docks).length > 0 &&
            scene.actions
              .map(action => {
                if (!action.device) {
                  action.device = getActionDevice(
                    action.dockNumber,
                    action.deviceNumber,
                    props.docks
                  );
                }

                return action;
              })
              .map(
                (
                  {
                    device,
                    dockNumber,
                    deviceNumber,
                    actionParameters
                  }: DeviceActionType,
                  sceneIndex
                ) => {
                  const {
                    SwitchFrameLedAction,
                    SwitchAction
                  } = actionParameters;

                  return (
                    <div
                      className="create-scene-action-item-wrapper"
                      key={`action-${device.id}`}
                    >
                      <RemoveActionButton
                        data-testid={`DeleteSceneAction${sceneIndex}`}
                        type="button"
                        onClick={() => {
                          setScene({
                            actions: [
                              ...scene.actions.filter(
                                actionToFilter =>
                                  actionToFilter.dockNumber !== dockNumber ||
                                  (actionToFilter.dockNumber === dockNumber &&
                                    actionToFilter.deviceNumber !==
                                      deviceNumber)
                              )
                            ]
                          });
                        }}
                        className="create-scene-action-item-remove-btn"
                      >
                        <SvgImage
                          inAssetsPath={getAssetPath(`icons/modal-close.svg`)}
                        />
                      </RemoveActionButton>

                      <SceneActionDetailsWrapper>
                        <SvgImage
                          className="create-scene-action-icon"
                          inAssetsPath={getAssetPath(
                            `${getDeviceIconBySymbol(device.symbol)}.svg`
                          )}
                        />
                        <div className="create-scene-action-item-text-wrapper">
                          <DeviceItemTitle>{device.name}</DeviceItemTitle>
                          <DeviceItemLabel>dock: {dockNumber}</DeviceItemLabel>
                        </div>
                      </SceneActionDetailsWrapper>

                      <div className="create-scene-action-item-state-wrapper">
                        {Object.keys(device.actions).some(actionKey =>
                          deviceActions.find(
                            deviceAction =>
                              deviceAction.key === actionKey &&
                              !deviceAction.trigger
                          )
                        ) && (
                          <div className="create-scene-action-item-state-toggle">
                            <ToggleButtonGroup
                              type="radio"
                              name="options"
                              value={SwitchFrameLedAction || SwitchAction}
                              onChange={value => {
                                if (SwitchFrameLedAction) {
                                  actionParameters.SwitchFrameLedAction = value;
                                }

                                if (SwitchAction) {
                                  actionParameters.SwitchAction = value;
                                }

                                setScene({
                                  ...scene
                                });
                              }}
                            >
                              <ToggleGroupBtn
                                data-testid={`StateOffAction${sceneIndex}`}
                                value="OFF"
                              >
                                OFF
                              </ToggleGroupBtn>
                              <ToggleGroupBtn
                                data-testid={`StateOnAction${sceneIndex}`}
                                value="ON"
                              >
                                ON
                              </ToggleGroupBtn>
                            </ToggleButtonGroup>
                          </div>
                        )}
                      </div>

                      <ActionParamWrapper>
                        {Number.isInteger(actionParameters.SoundNumber) && (
                          <SceneActionParamContainer>
                            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                            <audio
                              id="buzzerMelodyPlayer"
                              src={getAssetPath(
                                buzzerMelodies[actionParameters.SoundNumber].url
                              )}
                            />
                            <IconButton
                              icon={`${getAssetPath('icons/play.svg')}`}
                              className="create-scene-action-item-play-icon"
                              type="button"
                              onClick={() => {
                                document
                                  .getElementById('buzzerMelodyPlayer')
                                  // @ts-ignore
                                  .play();
                              }}
                            />
                            <Select
                              value={{
                                value: actionParameters.SoundNumber.toString(),
                                label:
                                  buzzerMelodies[actionParameters.SoundNumber]
                                    .name
                              }}
                              className="create-scene-action-item-buzzer-sound-select"
                              onChange={({ value }) => {
                                actionParameters.SoundNumber = parseInt(
                                  value,
                                  10
                                );
                                setScene({
                                  ...scene
                                });
                              }}
                              placeholder="Select buzzer melody"
                              options={buzzerMelodiesSelectOptions}
                            />
                          </SceneActionParamContainer>
                        )}

                        {actionParameters.Color && (
                          <SceneActionParamContainer data-testid="frame_led_colors">
                            <DropdownColorSelector
                              setLedColor={setLedColor}
                              actionParameters={actionParameters}
                            />
                            <InlineColorSelector
                              setLedColor={setLedColor}
                              actionParameters={actionParameters}
                            />
                          </SceneActionParamContainer>
                        )}
                      </ActionParamWrapper>

                      {actionParameters.Color && (
                        <ActionParamWrapper>
                          <SceneActionColorSliderContainer>
                            <ColorSlider
                              color={{
                                Color: actionParameters.Color,
                                // TODO standardize models on BE (sometimes with uppercase sometimes with lower)
                                // @ts-ignore
                                Brightness: actionParameters.brightness || 0
                              }}
                              onColorUpdate={brightness => {
                                actionParameters.Color = {
                                  ...actionParameters.Color
                                };
                                // TODO standardize models on BE (sometimes with uppercase sometimes with lower)
                                // @ts-ignore
                                actionParameters.brightness = brightness;
                                setScene({
                                  ...scene
                                });
                              }}
                            />
                          </SceneActionColorSliderContainer>
                        </ActionParamWrapper>
                      )}
                    </div>
                  );
                }
              )}
          {devicesListCollapsed ? (
            <CreateSceneDragAreaInfo
              clickable
              onClick={() => setDevicesListCollapsed(false)}
            >
              + Add next device
            </CreateSceneDragAreaInfo>
          ) : (
            <CreateSceneDragAreaInfo>
              Drag & drop devices from left panel
            </CreateSceneDragAreaInfo>
          )}
        </div>
      </CreatorPanel>
    </>
  );
};

export default CreateScenePanel;
